export const statSeason = "2025";
export const darkTeams = ["BAL", "JAX", "MIA", "NYG"];
export const noShadowTeams = ["TEN", "DEN", "LV", "TB", "NO", "TBD"]

